import { useEffect } from "react";

import { createUIAnalyticsEvent } from "./events";
import { trackEventPendo } from "./pendo";

type Options = {
  shouldShow: boolean;
  statusCode?: number;
  message?: string;
};

export const useTrackApiErrorPageView = ({
  shouldShow,
  statusCode,
  message
}: Options): void => {
  useEffect(() => {
    if (!shouldShow) return;
    trackEventPendo(
      createUIAnalyticsEvent.errorPage.viewed(message, "api_error", statusCode)
    );
  }, [shouldShow, statusCode, message]);
};
